const SUPABASE_URL = process.env.NEXT_PUBLIC_SUPABASE_URL ?? '';
const BUCKET = 'vehicle-photos';

type ImageSize = 'thumbnail' | 'card' | 'detail' | 'lightbox' | 'feed';

const SIZE_MAP: Record<ImageSize, number> = {
  thumbnail: 400,
  card: 800,
  detail: 1200,
  lightbox: 1920,
  feed: 1200,
};

/**
 * Builds a Supabase Storage public URL for a vehicle photo (raw object URL).
 * Responsive variants / CDN delivery are planned via Cloudflare (not Supabase Image Transform).
 * When that lands, branch on `_size` (see {@link SIZE_MAP}) to build the appropriate delivery URL.
 */
export function vehicleImageUrl(storagePath: string, _size: ImageSize = 'card'): string {
  if (!storagePath) return '/placeholder-vehicle.svg';
  return `${SUPABASE_URL}/storage/v1/object/public/${BUCKET}/${storagePath}`;
}

/**
 * Returns the raw public URL (no transform) — useful for feeds that need the original.
 */
export function vehicleRawUrl(storagePath: string): string {
  if (!storagePath) return '';
  return `${SUPABASE_URL}/storage/v1/object/public/${BUCKET}/${storagePath}`;
}
